<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Panel Kullanıcı Düzenle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Ad</h4>
          <v-text-field v-model="panelUser.firstName" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Soyad</h4>
          <v-text-field v-model="panelUser.lastName" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="panelUser.email"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Şifre sıfırla</h4>
          <v-btn
            depressed
            color="#4d48f9"
            style="color: white;"
            @click="resetPassword()"
          >
            Şifre Sıfırla
          </v-btn>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Rol</h4>
          <v-select
            v-model="panelUser.role"
            :items="allRoles"
            item-text="name"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            @change="roleChange"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Firma</h4>
          <v-select
            v-model="panelUser.companyId"
            :items="allCompanyList"
            @change="companyChange"
            item-text="companyName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Mağaza/Tabela</h4>
          <v-select
            v-model="panelUser.venueId"
            :items="allVenues"
            item-text="venueName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <!-- <v-col cols="12" md="4">
          <h4>Mağaza/Tabela</h4>
          <v-select
            v-model="panelUser.venueId"
            :items="allVenues"
            item-text="venueName"
            item-value="id"
            label="Select"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>-->

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="panelUser.active"
            :disabled="email == panelUser.email"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: right; color: white;"
            @click="panelUserUpdate()"
          >
            GÜNCELLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'panelUserDetail',
  data: () => ({
    valid: true,
    email: '',
    allRoles: [
      {
        id: 'PanelUser',
        name: 'Admin',
      },
      {
        id: 'PanelVenueUser',
        name: 'Üye İş Yerleri',
      },
      {
        id: 'PanelReportUser',
        name: 'Rapor Erişimi',
      },
      {
        id: 'AppliedMerchantUser',
        name: 'Başvuru Yapılmış',
      },
    ],
    errorList: [],
    dialog: false,
  }),
  computed: mapGetters(['panelUser', 'allVenues', 'allCompanyList']),
  created() {
    let user = {
      id: this.$route.params.id,
    }
    this.getPanelUser(user).then((userResponse) => {
      console.log('userResponse', userResponse)
      this.email = localStorage.getItem('email')
      this.getCompanieList().then((response) => {
        this.getVenues(userResponse.companyId).then((data) => {
          if (userResponse.role != this.allRoles[0].id)
            this.addAllVenuesOption()
        })
      })
    })
  },
  methods: {
    ...mapActions([
      'getPanelUser',
      'putUpdatePanelUser',
      'getVenues',
      'getCompanieList',
      'getResetPanelUserPassword',
    ]),
    resetPassword() {
      let user = {
        email: this.panelUser.email,
      }
      this.getResetPanelUserPassword(user)
        .then((response) => {
          if (response.data.payload) {
            alert('Şifre başarıyla mail adresine gönderilmiştir')
          } else {
            alert(response.friendlyMessage.message)
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    companyChange(companyId) {
      console.log('com', companyId)
      this.getVenues(companyId).then((data) => {
        this.panelUser.venueId = data[0].id
        this.addAllVenuesOption()
      })
    },
    routepanelUsers() {
      this.$router.push('/dashboard/users/panelUsers')
    },
    panelUserUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.putUpdatePanelUser(this.panelUser).then((res) => {
          this.routepanelUsers()
        })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.errorList = errors

        this.dialog = true
      }
    },
    addAllVenuesOption() {
      this.allVenues.unshift({ id: 0, venueName: 'Hepsi' })
      if (this.panelUser.allVenue == true && this.panelUser.venueId == null)
        this.panelUser.venueId = 0
    },
    roleChange(nw) {
      if (nw == this.allRoles[0].id) {
        if (this.allVenues[0].id == 0) {
          this.allVenues.splice(0, 1)
          if (this.panelUser.venueId == 0) this.panelUser.venueId = null
        }
      } else {
        this.addAllVenuesOption()
      }
    },
  },
}
</script>
